import { getIdContoNumConto } from './getIdContoNumConto';

export function getAccountIds() {
    return localStorage.getItem('lastLoggedUserAccountIds') || getIdContoNumConto();
}
